import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "card group-edit-panel" }
const _hoisted_2 = { class: "card-header bg-primary text-white d-flex justify-content-between align-items-center" }
const _hoisted_3 = { class: "card-body" }
const _hoisted_4 = { class: "d-flex justify-content-between align-items-center mb-3" }
const _hoisted_5 = { class: "mb-3" }
const _hoisted_6 = ["value"]
const _hoisted_7 = { class: "table table-bordered text-center calendar-table" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "d-flex gap-2 mt-3" }
const _hoisted_10 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "group-edit-backdrop",
    onClick: _cache[7] || (_cache[7] = _withModifiers(
//@ts-ignore
(...args) => ($options.cancel && $options.cancel(...args)), ["self"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[8] || (_cache[8] = _createElementVNode("h5", { class: "mb-0" }, "Edit non-availability group", -1)),
        _createElementVNode("button", {
          type: "button",
          class: "btn-close btn-close-white",
          "aria-label": "Close",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($options.cancel && $options.cancel(...args)))
        })
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-sm btn-outline-secondary",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($options.previousMonth && $options.previousMonth(...args)))
          }, "< Prev"),
          _createElementVNode("strong", null, _toDisplayString($options.monthLabel), 1),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-sm btn-outline-secondary",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($options.nextMonth && $options.nextMonth(...args)))
          }, "Next >")
        ]),
        _createElementVNode("div", _hoisted_5, [
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($data.selectedTypeId) = $event)),
            class: "form-select form-select-sm d-inline-block",
            style: {"width":"220px"}
          }, [
            _cache[9] || (_cache[9] = _createElementVNode("option", {
              value: null,
              disabled: ""
            }, "Select type", -1)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.nonAvailabilityTypes, (type) => {
              return (_openBlock(), _createElementBlock("option", {
                key: type.nonAvailabilityTypeId,
                value: type.nonAvailabilityTypeId
              }, _toDisplayString(type.name), 9, _hoisted_6))
            }), 128))
          ], 512), [
            [
              _vModelSelect,
              $data.selectedTypeId,
              void 0,
              { number: true }
            ]
          ]),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($data.reason) = $event)),
            class: "form-control form-control-sm d-inline-block ms-2",
            style: {"width":"auto"},
            placeholder: "Reason / remarks (optional)"
          }, null, 512), [
            [_vModelText, $data.reason]
          ])
        ]),
        _createElementVNode("table", _hoisted_7, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.weekdayLabels, (label) => {
                return (_openBlock(), _createElementBlock("th", { key: label }, _toDisplayString(label), 1))
              }), 128))
            ])
          ]),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.calendarWeeks, (week, wIdx) => {
              return (_openBlock(), _createElementBlock("tr", { key: wIdx }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(week, (cell) => {
                  return (_openBlock(), _createElementBlock("td", {
                    key: cell.key,
                    class: _normalizeClass(["calendar-cell", $options.cellClass(cell)]),
                    onClick: ($event: any) => ($options.onCellClick(cell))
                  }, [
                    _createElementVNode("div", null, _toDisplayString(cell.day), 1)
                  ], 10, _hoisted_8))
                }), 128))
              ]))
            }), 128))
          ])
        ]),
        ($data.message)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["alert mt-2", $data.messageType]),
              role: "alert"
            }, _toDisplayString($data.message), 3))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-sm btn-primary",
            disabled: $data.loading || !$data.selectedTypeId,
            onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => ($options.save && $options.save(...args)))
          }, "Save", 8, _hoisted_10),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-sm btn-outline-secondary",
            onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => ($options.cancel && $options.cancel(...args)))
          }, "Cancel")
        ])
      ])
    ])
  ]))
}